module.exports = __webpack_public_path__ + "img/cloth_g3_pants-09.859494db.svg";